import { CampaignAbortedNotice } from "./components/CampaignAbortedNotice";
import { Wizard } from "./components/Wizard";
import { useUploadSession } from "./hooks/useUploadSession";

/**
 * UploadPage — 顧客アップロード画面のエントリポイント。
 *
 * URL: /u/:campaignRecordId
 * `?t=<token>` はサーバ (backend/officeinput.VerifyHandler, ADR-0025) が検証しセッション Cookie を
 * 発行した上で本 URL へ 303 リダイレクトするため、本画面には token が渡ってこない。
 * 認証状態は useUploadSession が GET /api/upload-session の結果で判定する。
 *
 * ヘッダはカードを使わず、会社名と実施年度をプレーンに 1 段で表示する。
 */
export function UploadPage() {
  const { session } = useUploadSession();

  if (session.status === "loading") {
    return (
      <main className="mx-auto max-w-3xl px-6 py-10">
        <p className="text-sm text-muted-foreground">読み込み中…</p>
      </main>
    );
  }

  if (session.status === "campaign_aborted") {
    return (
      <main className="mx-auto max-w-3xl px-6 py-10">
        <CampaignAbortedNotice />
      </main>
    );
  }

  if (session.status === "invalid") {
    return (
      <main className="mx-auto max-w-3xl px-6 py-10">
        <section className="rounded-lg border border-border bg-card p-6 shadow-sm">
          <h1 className="text-base font-semibold">リンクが無効か期限切れです</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            お手数ですが、ご案内メールを再度ご確認いただくか、管理者にお問い合わせください。
          </p>
        </section>
      </main>
    );
  }

  const { companyName, fiscalYear } = session.session;

  return (
    <main className="mx-auto max-w-3xl px-6 py-10">
      <header className="mb-10 border-b border-border pb-6">
        <h1 className="text-2xl font-semibold tracking-tight">{companyName}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {fiscalYear} 年度 実施 ストレスチェック の名簿アップロード
        </p>
      </header>

      <Wizard />
    </main>
  );
}
